import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsBuzzfeedComponent } from './simple-icons-buzzfeed.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsBuzzfeedComponent ],
    exports:      [ SimpleIconsBuzzfeedComponent ],
    bootstrap:    []
})
export class SimpleIconsBuzzfeedModule {}
